export default `
  query PickupLocations ($area: AreaInput, $filters: PickupLocationFilterInput, $sort: PickupLocationSortInput, $pageSize: Int, $currentPage: Int, $productsInfo: [ProductInfoInput]) {
    pickupLocations(area: $area, filters: $filters, sort: $sort, pageSize: $pageSize, currentPage: $currentPage, productsInfo: $productsInfo){
      items {
        name
      }
      total_count
    }
  }
`
